import "element-scroll-polyfill";

// toBlob polyfill from https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
        value: function(callback: Function, type: any, quality: any) {
            const dataURL = this.toDataURL(type, quality).split(",")[1];

            setTimeout(() => {
                const binStr = atob(dataURL),
                    len = binStr.length,
                    arr = new Uint8Array(len);

                for (let i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || "image/png" }));
            });
        }
    });
}
